import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/homeData';

export default function LatestUpdates() {
  return (
    <section className="py-16 md:py-20 bg-background-50" aria-labelledby="latest-title">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-10">
            <div>
              <h2 id="latest-title" className="font-heading text-3xl md:text-4xl text-foreground-950">
                最新<span className="text-primary-500">更新</span>
              </h2>
              <p className="text-foreground-600 text-sm mt-2">
                实时追踪最新汉化章节，精彩内容即刻呈现
              </p>
            </div>
            <span className="inline-flex items-center px-4 py-2 rounded-full bg-secondary-100 text-secondary-800 text-sm font-medium whitespace-nowrap">
              今日更新 {latestUpdates.length} 部
            </span>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {latestUpdates.map((item) => (
              <Link
                key={item.id}
                to={`/manhua/${item.id}`}
                className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500/90 text-background-50 text-xs font-medium">
                    {item.updatedAt}
                  </div>
                </div>
                <div className="p-3">
                  <h3 className="text-foreground-900 text-sm font-medium truncate group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <div className="flex items-center justify-between mt-2">
                    <span className="text-foreground-500 text-xs">{item.author}</span>
                    <span className="text-primary-600 text-xs font-medium">
                      {item.latestChapter}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}